import { useEffect } from 'react'

import { Tooltip } from 'antd'
import { IToolTip } from './types'

import { useValue } from '@hooks/useValue'
import { useDeviceType } from '@hooks/useDeviceType'


/** Компонента ToolTip */
export const ToolTip = ({ children, title, placement = 'bottom', isVisible = true }: IToolTip) => {
    const deviceType = useDeviceType()

    const toolTipVisible = useValue<boolean>(isVisible)

    useEffect(() => {
        if (deviceType !== 'desktop') toolTipVisible.setValue(false)
    }, [deviceType, toolTipVisible])

    return <>
        <Tooltip mouseLeaveDelay={0} arrow={{ pointAtCenter: true }} placement={placement} title={toolTipVisible.value ? title : null} color={'var(--color_bg_accent_primary)'}>
            <div>
                {children}
            </div>
        </Tooltip>
    </>
}